import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = ["onChange", "onBlur"]
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_5 = { class: "form-text" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = ["onUpdate:modelValue"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_label = _resolveComponent("bs5-base-label")!
  const _component_Field = _resolveComponent("Field")!
  const _component_bs5_form_field = _resolveComponent("bs5-form-field")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    as: "",
    "validation-schema": _ctx.schema
  }, {
    default: _withCtx(({ meta, handleSubmit }) => [
      _createVNode(_component_bs5_base_modal, {
        title: _ctx.$t('licenses.generateTitle'),
        visible: _ctx.visible,
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            novalidate: "",
            onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.generateLicense)), ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_bs5_base_label, { for: "licenceRequest" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("licenses.requestFile")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Field, {
                name: "licenceRequest",
                "model-value": _ctx.licenceRequest
              }, {
                default: _withCtx(({ handleChange, handleBlur, meta: fileMeta, errorMessage }) => [
                  _createElementVNode("input", {
                    id: "licenceRequest",
                    type: "file",
                    accept: ".xml,application/xml,text/xml",
                    class: _normalizeClass(["form-control", { 'is-valid': fileMeta.valid && fileMeta.touched, 'is-invalid': !!errorMessage && fileMeta.touched }]),
                    onChange: ($event: any) => (_ctx.onFileChange($event, handleChange)),
                    onBlur: handleBlur
                  }, null, 42, _hoisted_3),
                  (errorMessage && fileMeta.touched)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("licenses.requestFileHint")), 1)
            ]),
            _createVNode(_component_bs5_form_field, {
              id: "validTo",
              name: "validTo",
              type: "date",
              label: _ctx.$t('licenses.validTo'),
              hint: _ctx.$t('licenses.validToHint'),
              modelValue: _ctx.license.validTo,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.license.validTo) = $event))
            }, null, 8, ["label", "hint", "modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_bs5_base_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("licenses.modules")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFeatures, (label, key) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: key,
                    class: "form-check"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.license[key]) = $event)
                    }, null, 8, _hoisted_7), [
                      [_vModelCheckbox, _ctx.license[key]]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`licenses.features.${key}`)), 1)
                  ]))
                }), 128))
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("button", {
              type: "submit",
              class: "d-none",
              tabindex: "-1",
              "aria-hidden": "true"
            }, null, -1))
          ], 40, _hoisted_1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
          _createVNode(_component_bs5_save_button, {
            loading: _ctx.saving,
            disabled: !meta.valid,
            onClick: ($event: any) => (handleSubmit($event, _ctx.generateLicense))
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-file-earmark-plus" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t("licenses.generate")), 1)
            ]),
            _: 2
          }, 1032, ["loading", "disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["title", "visible", "onClose"])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}